import { useState } from "react";
import { useNavigate } from "react-router-dom";

const ADMIN_AUTH_URL = "https://dimwpgeuqvtzlrlvveme.supabase.co/functions/v1/admin-auth";

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    if (!username.trim() || !password.trim()) {
      setError("Tüm alanları doldurunuz.");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(ADMIN_AUTH_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string}`,
        },
        body: JSON.stringify({ username: username.trim(), password }),
      });

      const data = await response.json();

      if (data.success && data.user) {
        sessionStorage.setItem("artpos_admin", JSON.stringify(data.user));
        navigate("/admin/dashboard");
      } else {
        setError(data.message || "Kullanıcı adı veya şifre hatalı.");
      }
    } catch {
      setError("Bağlantı hatası. Lütfen tekrar deneyin.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background-50 px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="mx-auto mb-4">
            <img
              src="https://public.readdy.ai/ai/img_res/0bc3c21d-f175-4039-a061-cbb43a619b2e.png"
              alt="ART POS Logo"
              className="w-28 h-28 mx-auto object-contain"
            />
          </div>
          <h1 className="text-xl font-bold text-foreground-950 font-heading"><a id="admin-login-title">ART POS</a></h1>
          <p className="text-sm text-foreground-500 mt-1">Admin Paneli</p>
        </div>

        <form onSubmit={handleLogin} className="bg-background-50 border border-background-200/70 rounded-2xl p-6 space-y-4">
          <div>
            <label className="block text-xs font-medium text-foreground-500 mb-1">Kullanıcı Adı</label>
            <div className="relative">
              <i className="ri-user-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400"></i>
              <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} className="w-full pl-10 pr-3 py-2.5 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400" placeholder="Kullanıcı adı" />
            </div>
          </div>

          <div>
            <label className="block text-xs font-medium text-foreground-500 mb-1">Şifre</label>
            <div className="relative">
              <i className="ri-lock-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400"></i>
              <input type={showPassword ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} className="w-full pl-10 pr-12 py-2.5 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400" placeholder="Şifre" />
              <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-1/2 -translate-y-1/2 text-foreground-400 hover:text-foreground-600 cursor-pointer">
                <i className={showPassword ? "ri-eye-off-line" : "ri-eye-line"}></i>
              </button>
            </div>
          </div>

          {error && (
            <div className="bg-accent-100 text-accent-700 text-xs rounded-lg px-3 py-2">{error}</div>
          )}

          <button type="submit" disabled={loading} className="w-full py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-sm font-medium transition-colors disabled:opacity-60 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap">
            {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
          </button>

          <p className="text-center text-xs text-foreground-400">
            Demo: <strong>admin</strong> / <strong>admin123</strong>
          </p>
        </form>
      </div>
    </div>
  );
}